import { Component, OnInit, OnDestroy } from '@angular/core';
import { UsersService } from 'app/pages/users/users.service';
import { Subscription } from 'rxjs/Subscription';
import {
  IContact,
  ISupportChannel,
} from 'app/core/interfaces/configuration-data.interface';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { T2ThemeService } from 'app/trip2-theme/t2-theme.service';
import { IProfile } from 'app/core/interfaces/user.interface';

@Component({
  selector: 'app-t2-help',
  templateUrl: './t2-help.component.html',
  styleUrls: ['./t2-help.component.scss'],
})
export class T2HelpComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  protected profile: IProfile | null = null;
  protected supportConfig: ISupportChannel | null = null;

  CHANNEL_TYPES = {
    crm: 'crm',
    web: 'web',
    emailSuport: 'email-support',
    phone: 'phone'
  };

  constructor(
    private userService: UsersService,
    private configurationService: T2ThemeService,
    private sweetAlertHelper: SweetAlertHelper
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.userService.currentUserInformation$.subscribe({
        next: (currentUserData) => {
          if (currentUserData) {
            this.profile = {
              names: currentUserData.fullname,
              modifiedon: currentUserData.modifiedon,
              avatar: currentUserData.userphoto,
              email: currentUserData.emailaddress,
            };
          }
        },
        error: (err) => {
          this.sweetAlertHelper.captureException(err);
        },
      }),

      this.configurationService
        .getConfigurationData()
        .subscribe({
          next: (data) => {
            if (data) {
              const parsed = JSON.parse(data);
              this.supportConfig = parsed.supportChannels;
              this.configurationService.setSupportAvailability(true);
            }
          },
          error: (err) => {
            this.sweetAlertHelper.captureException(err);
          },
        }),
    );
  }

  getChannelLink(type: string, phoneNumber: IContact): string {
    if (!this.supportConfig || !this.profile) {
      return '';
    }

    switch (type) {
      case this.CHANNEL_TYPES.crm:
        return `${this.supportConfig.linkCrm}${this.profile.names || ''}&email=${this.profile.email || ''}`;
      case this.CHANNEL_TYPES.web:
        return this.supportConfig.linkTrip;
      case this.CHANNEL_TYPES.emailSuport:
        return `mailto:${this.supportConfig.emailSupport}`;
      case this.CHANNEL_TYPES.phone:
        return `tel:${phoneNumber.phone}`;
      default:
        return '';
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/trip2-theme/components/t2-help/t2-help.component.ts